<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-团队业绩-计算单-创建结算单
      -->
  <div>
    <div class="product-content">
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <!--基础设置-->
        <div class="active-basic">
          <el-form-item label="选择日期">
            <el-select size="small" v-model="form.year" placeholder="年份">
              <el-option label="请选择年份" value="0"></el-option>
              <el-option v-for="(item, index) in years" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            <el-select size="small" v-model="form.month" placeholder="月份">
              <el-option label="请选择月份" value="0"></el-option>
              <el-option v-for="(item, index) in months" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注释">

            <div class="gray9">根据月份创建月度业绩奖，按照设置选择固定等级发放</div>

          </el-form-item>
        </div>
        <!--提交-->
        <el-form-item>
          <el-button size="small" @click="cancelFunc">返回</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
        </el-form-item>
      </el-form>
    </div>


  </div>
</template>
<script>
import GroupAwardApi from '@/api/groupaward.js';
export default {
  components: {},
  data() {
    return {
      form: {
        /*年份*/
        year: 0,
        /*月份*/
        month: 0
      },
      years : [],
      months: [],
      grade:[],
      /*判断是否正在加载*/
      loading: false,
    };
  },
  created() {
    /*获取设置*/
    this.getYearAndMonth();
  },
  methods: {
    /*获取设置*/
    getYearAndMonth() {
      let self = this;
      let Params = {};
      GroupAwardApi.getYearAndMonth(Params, true)
        .then(data => {
          self.loading = false;
          self.years = data.data.years;
          self.months = data.data.months;
          self.grade = data.data.gradeList;
        })
        .catch(error => {});
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = self.form;
          self.loading = true;
          GroupAwardApi.createStatement(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，结算单创建成功!',
                type: 'success'
              });
              self.$router.push('/plus/groupaward/index');
              localStorage.setItem('activeName','second')
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消*/
    cancelFunc() {
      /*存储缓存*/
      localStorage.setItem('activeName','second')
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/groupaward/statement/create.vue